export const mockupData = {
    flatiron: {
        name: 'Flatiron',
        backgroundImage: '/img/demo/flatiron.png',
        externalKey: '684522ac5f8b2b65abb18a0b',
    },
    mikesbikes: {
        name: 'MikesBikes',
        backgroundImage: '/img/demo/mikesbikes.png',
        externalKey: '684522f2f0d6016d7da40fae',
        // externalKey: '6718be2310310e41ab5276ef',
    },
}